import { useEffect, useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { useToast } from "@/hooks/use-toast";
import { periodParams } from "@/lib/reportsApi";
import { REPORTS } from "@/constants/testIds";
import ExportButtons from "@/components/reports/ExportButtons";
import { MostSoldTable, MostProfitableTable } from "@/components/reports/ServicesRankingTables";

/** Reporte de Servicios: mas vendidos y mas rentables en el periodo elegido. */
export default function ServicesTab({ period }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const { toast } = useToast();

  useEffect(() => {
    if (period.period === "custom" && (!period.start || !period.end)) return;
    setLoading(true);
    api.get("/reports/services", { params: periodParams(period) })
      .then(({ data }) => setData(data))
      .catch((err) => toast({ title: "No se pudo cargar Servicios", description: formatApiErrorDetail(err.response?.data?.detail), variant: "destructive" }))
      .finally(() => setLoading(false));
  }, [period]); // eslint-disable-line react-hooks/exhaustive-deps

  if (loading || !data) return <p className="text-center text-muted-foreground py-12">Cargando servicios...</p>;

  return (
    <div className="space-y-4">
      <div className="flex justify-end">
        <ExportButtons reportKey="services" period={period} />
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <MostSoldTable data={data.most_sold} testId={REPORTS.servicesMostSoldTable} />
        <MostProfitableTable data={data.most_profitable} testId={REPORTS.servicesMostProfitableTable} />
      </div>
    </div>
  );
}
